var map = {
	"./3kuratorky.png": 156,
	"./beauty.png": 157,
	"./chantall.png": 158,
	"./denisamenu.png": 159,
	"./denisapodpivniky.png": 160,
	"./hlavickovy2.png": 161,
	"./hospoda.png": 162,
	"./logo.png": 163,
	"./oznamko.png": 164,
	"./patko.png": 68,
	"./shipyard.png": 165,
	"./tablo.png": 166,
	"./tablo2.png": 167,
	"./vio.png": 168
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44;